import React from 'react'
import PropTypes from 'prop-types'
import { Button, Box, UIManager, ErrorBoundary, Toaster, Text } from '@deseretbook/react-ui'
import { usePopup } from '@deseretbook/react-utils'
import ShoppingCartIcon from '@deseretbook/icons/react/shopping-cart'
import CartSidebar from './CartSidebar'

UIManager.injectGlobal()

/**
 * Cart Button
 *
 * @param {number} count - number of items in the current user's cart
 *
 * @returns {function} Component
 */
export const CartButton = ({ count }) => {
  const [totalQuantity, setTotalQuantity] = React.useState(count)
  const popup = usePopup()

  /**
   * Opens the sidebar.
   */
  const openSidebar = () => {
    if (window.CustomerSupport) {
      window.CustomerSupport.closeChat()
      window.CustomerSupport.hideChatBubble()
    }

    popup.open()
  }

  /**
   * Closes the sidebar.
   */
  const closeSidebar = () => {
    if (window.CustomerSupport && popup.isOpen) {
      window.CustomerSupport.showChatBubble()
    }

    popup.close()
  }

  return (
    <React.Fragment>
      <Toaster />
      {/* Christmas theme, add: style={{ background: 'transparent' }}  */}
      <Button
        type="button"
        color="secondary"
        {...popup.triggerProps}
        onClick={openSidebar}
        size="small"
        style={{ minWidth: totalQuantity ? '3.5rem' : '2.5rem' }}
      >
        <Box alignItems="center">
          {totalQuantity ? (
            <Text
              color="light"
              display="inline-block"
              size="small"
              as="span"
              style={{
                marginRight: '0.25rem',
              }}
            >
              {totalQuantity}
            </Text>
          ) : null}
          <ShoppingCartIcon width="1.5em" height="1.5em" />
        </Box>
      </Button>
      <ErrorBoundary failsSilently>
        <CartSidebar
          popupProps={popup.popupProps}
          onClose={closeSidebar}
          onUpdate={order => {
            setTotalQuantity(order.totalQuantity)
          }}
          orderNumber={window.__USER__ && window.__USER__.currentOrder}
          orderToken={window.__USER__ && window.__USER__.orderToken}
          isReadOnly={window.location && window.location.pathname.indexOf('/checkout') > -1}
        />
      </ErrorBoundary>
    </React.Fragment>
  )
}

CartButton.propTypes = {
  count: PropTypes.number,
}
